<template>
  <div>
    <v-list-item v-if="!$vuetify.breakpoint.mobile && !readOnly && $store.getters.company.connectedToAccounting">
      <v-spacer/>
      <v-menu offset-y eager>
        <template v-slot:activator="{ on }">
          <v-btn small icon v-on="on" v-on:click.prevent><v-icon>mdi-cog-outline</v-icon></v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="sync"><v-list-item-title>Sync currencies with QBO</v-list-item-title></v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>

    <v-data-table ref="table" class="purtrak-table"  height="calc(100vh - 154px)"
        :items="currencies" :headers="headers" no-data-text="No currencies defined"
        disable-pagination hide-default-footer calculate-widths fixed-header>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small @click="add"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn small icon @click.stop="deleteCurrency(item)"><v-icon small >mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="addMode" persistent max-width="300">
      <v-card>
        <v-card-title>Add currency</v-card-title>
        <v-card-text class="pb-0">
          <v-form v-model="valid" ref="form">
            <v-container class="mt-4">
              <v-row dense no-gutters>
                <v-col cols="8">
                  <v-text-field label="Code" v-model="code" :rules="[fieldRules.required,fieldRules.maxLength(3)]" outlined dense/>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="addMode=false">Cancel</v-btn>
          <v-btn color="primary" @click="save">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <delete-object v-model="showDelete" :name="code" @delete="performDeleteCurrency"/>
  </div>
</template>

<script>
export default {
  name: 'SettingCurrencies',
  data() {
    return {
      currencies: [],
      code: '',
      valid: false,
      addMode: false,
      showDelete: false,
      defaultColumns: [{ value: 'code', visible:true}],
      headers: [{ text: 'CURRENCY', value: 'code', filterable:true,sortable:true},
                { text: '' , value:'action', width:'5%', filterable:false,sortable:false,sortable:false,align:'center'}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      const results = await this.$apiCall(`query SettingCurrencies {
                                             company {
                                                currencies {
                                                  code
                                                }
                                              }
                                            }`,
                                          {});
      if (!results.error)
        this.currencies = results.data.company.currencies;
      this.loading = false;
    },
    add() {
      this.code = '';
      this.addMode = true;
      this.$nextTick(() => this.$refs.form.validate());
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      const results = await this.$apiCall(`mutation SettingCurrencies($code:String!) {
                                                currencyCreate(code:$code) {
                                                  code
                                                }
                                              }`,
                                          {code:this.code}, true);
      if (!results.error) {
        this.currencies.push(results.data.currencyCreate);
        this.addMode = false;
      }
      else
        this.$store.commit('setError', {type:'error',message:results.error.message});

    },
    deleteCurrency(currency) {
      this.code = currency.code;
      this.showDelete = true;
    },
    async performDeleteCurrency() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingCurrencies($code:String!) {
                                                currencyDelete(code:$code) {
                                                  code
                                                }
                                              }`,
                                          {code:this.code}, true);
      this.loading = false;
      if (!results.error) {
        const index = this.currencies.findIndex(currency => currency.code === this.code);
        this.currencies.splice(index, 1);
      }
      else
        this.$store.commit('setError', {type:'error',message:results.error.message});
    },
    async sync() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingCurrencies {
                                             accountingIntegrationSync(step:"currencies") {name}
                                           }`, {});
      await this.load();
      if (!results.error)
        this.$store.commit('setError', {type:'success',message:`Synced currencies with QBO`});
    }
  }
}
</script>